'use client';

import React, { ReactNode, useState } from 'react';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab/Tab';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import tabsStyles from '@/blocks/components/Controls/Tabs/styles.module.scss';

import styles from './styles.module.scss';

export function BuyOrTradeTabs({
  buy,
  trade,
  assetBase,
}: {
  assetBase: string;
  buy?: ReactNode;
  trade: ReactNode;
}) {
  const [value, setValue] = useState(buy ? TabValue.BUY : TabValue.TRADE);
  const tr = useTranslations('pages.priceCharts.asset.sections.sidebar.buyOrTrade');

  if (!buy && trade) {
    return <>{trade}</>;
  }

  return (
    <TabContext value={value}>
      {buy && trade ? (
        <TabList
          variant={'fullWidth'}
          scrollButtons={false}
          className={classNames(tabsStyles.outlinedTabs, styles.buyOrTradeTabs)}
          onChange={(event, newValue) => setValue(newValue)}
        >
          <Tab disableRipple label={tr.rich('buy.label', { assetBase })} value={TabValue.BUY} />
          <Tab disableRipple label={tr.rich('trade.label', { assetBase })} value={TabValue.TRADE} />
        </TabList>
      ) : null}
      <TabPanel value={TabValue.BUY}>{buy}</TabPanel>
      <TabPanel value={TabValue.TRADE}>{trade}</TabPanel>
    </TabContext>
  );
}

export enum TabValue {
  BUY = 'BUY',
  TRADE = 'TRADE',
}
